import card_border_1 from './card_border_1.svg';
import card_border_2 from './card_border_2.svg';
import card_icon from './card_icon.png';

export const cards = {
  card_border_1: card_border_1,
  card_border_2: card_border_2,
  card_icon: card_icon.src,
};
